// This is the webpack entry point
// Refrain from putting actual code in here and just import the modules you need;

import VendorScriptLoader from './utility/vendor-script-loader';
import HeaderNavMenu from './components/global/nav-menu';
import FooterMenu from './components/global/footer-menu';
import './components/global/modal/redirect-modal';
import AnchorSmoothScroll from './utility/anchor-smooth-scroll';
import ElementBottomPositionMobileFix from './utility/element-bottom-position-mobile-fix';
import AOS from 'aos';
import 'aos/dist/aos.css';

window.addEventListener("load", () => {
  AOS.init();
});

/**
 * Code-splitting :: Blocks
 *
 * Manages blocks that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerBlocks() {
  // sass dev
  if (document.querySelector('.saas-header')) {
    import('~scripts/blocks/saas-header');
  }
  if (document.querySelector('.saas-product-highlights')) {
    import('~scripts/blocks/saas-product-highlights');
  }
  if (document.querySelector('.saas-steps')) {
    import('~scripts/blocks/saas-steps');
  }
  if (document.querySelector('.saas-cta')) {
    import('~scripts/blocks/saas-cta');
  }
  // sass dev end


  if ( document.querySelector('.text-and-carousel') ) {
    import('~scripts/blocks/text-and-carousel');
  }

  if ( document.querySelector('.post-carousel-sec') ) {
    import('~scripts/blocks/post-carousel');
  }

  if ( document.querySelector('.icon-blocks-sec') ) {
    import('~scripts/blocks/icon-blocks');
  }

  if ( document.querySelector('.post-content') ) {
    import('~scripts/blocks/post-content');
  }

  if ( document.querySelector('.full-width-image-video') ) {
    import('~scripts/blocks/full-width-image-video');
  }

  if ( document.querySelector('.full-width-image-text') ) {
    import('~scripts/blocks/full-width-image-text');
  }

  if ( document.querySelector('.basic-header-sec') ) {
    import('~scripts/blocks/basic-header');
  }

  if ( document.querySelector('.js-basic-header-with-nav') ) {
    import('~scripts/blocks/basic-header/basic-header-with-nav');
  }

  if ( document.querySelector('.image-background-header') ) {
    import('~scripts/blocks/image-background-header');
  }

  if ( document.querySelector('.description-header-sec') ) {
    import('~scripts/blocks/description-header');
  }

  if ( document.querySelector('.z-frame-sec') ) {
    import('~scripts/blocks/z-frame-image-header');
  }

  if ( document.querySelector('.js-z-frame-cta') ) {
    import('~scripts/blocks/z-frame-cta');
  }

  if ( document.querySelector('.icons-and-descriptions') ) {
    import('~scripts/blocks/icons-and-descriptions');
  }

  if ( document.querySelector('.horizontal-rule') ) {
    import('~scripts/blocks/horizontal-rule');
  }

  if ( document.querySelector('.case-study-quote-image') ) {
    import('~scripts/blocks/case-study-quote-image');
  }

  if ( document.querySelector('.case-study-quote-column') ) {
    import('~scripts/blocks/case-study-quote-column');
  }

  if ( document.querySelector('.js-case-study-indented-text-columns') ) {
    import('~styles/blocks/case-study-indented-text-columns/index.scss');
  }

  if ( document.querySelector('.blog-image') ) {
    import('~scripts/blocks/blog-image');
  }

  if ( document.querySelector('.blog-pull-quote') ) {
    import('~scripts/blocks/blog-pull-quote');
  }

  if ( document.querySelector('.basic-image-text') ) {
    import('~scripts/blocks/basic-image-text');
  }

  if ( document.querySelector('.basic-button') ) {
    import('~scripts/blocks/basic-button');
  }

  if ( document.querySelector('.js-map') ) {
    // Loads component only after vendor file is loaded
    document.addEventListener('google-maps:loaded', () => {
      // alert('Google Maps loaded');
    });

    VendorScriptLoader.outputGoogleMapsScriptTag();
  }

  if ( document.querySelector('.js-secondary-nav') ) {
    import('~scripts/blocks/secondary-nav');
  }

  if ( document.querySelector('.js-links-with-images') ) {
    import('~styles/blocks/links-with-images/index.scss');
  }

  if ( document.querySelector('.js-hero-carousel') ) {
    import('~scripts/blocks/hero-carousel').then(component => {
      component.default.init();
    });
  }

  if ( document.querySelector('.js-pull-out-text') ) {
    import('~scripts/blocks/pull-out-text');
  }

  if ( document.querySelector('.js-form-cta') ) {
    import('~scripts/blocks/form-cta');
  }

  if ( document.querySelector('.js-double-logo-carousel') ) {
    import('~scripts/blocks/double-logo-carousel');
  }

  if ( document.querySelector('.js-faq-block') ) {
    import('~scripts/blocks/faq');
  }

  if ( document.querySelector('.js-team-listing') ) {

    document.addEventListener('multiple-vendors:loaded', () => {
      import('~scripts/blocks/team-listing');
    });

    VendorScriptLoader.outputVendorScriptTags(['vendor-vue']);
  }

  if ( document.querySelector('.js-office-contacts') ) {
    // Loads component only after vendor file is loaded
    document.addEventListener('vendor-moment:loaded', () => {
      import('~scripts/blocks/office-contacts');
    });

    VendorScriptLoader.outputVendorScriptTag('vendor-moment');
  }

  if ( document.getElementById('feed') ) {
    // Loads component only after vendor files are loaded
    document.addEventListener('multiple-vendors:loaded', () => {
      import('~scripts/blocks/feed');
    });

    VendorScriptLoader.outputVendorScriptTags(['vendor-vue', 'vendor-moment']);
  }
}

/**
 * Code-splitting :: Components
 *
 * Manages components that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerComponents() {
  // if ( document.querySelector('.js-example-component') ) {
  //   // Loads component only after vendor file is loaded
  //   document.addEventListener('vendor-vue:loaded', () => {
  //     import('~scripts/components/example');
  //   });
  //
  //   VendorScriptLoader.outputVendorScriptTag('vendor-vue');
  // }

  // if ( document.querySelector('.js-example-component') ) {
  //   import('~scripts/components/example');
  // }

  // Form custom choice fields
  if ( document.querySelectorAll('.form-style .gfield_select').length ) {
    import('~scripts/components/form/form-custom-select-styles').then(component => {
      component.default.init('.form-style');
    });
  }

  // Hubspot form styles
  if ( document.querySelector('.hbspt-form') ) {
    import('~scripts/components/form/hubspot-form-styles').then(component => {
      component.default.init();
    });
  }

  // Generic form (i.e. search form)
  if ( document.querySelector('.js-generic-form  select').length ) {
    import('~scripts/components/form/generic-form-custom-select-styles').then(component => {
      component.default.init('.js-generic-form');
    });
  }

  // Wordpress pagination
  if ( document.querySelector('.js-wp-pagination') ) {
    import('~styles/components/wp-pagination/index.scss');
  }

  if ( document.querySelector('.js-simple-modal-wrapper') ) {
    import('~scripts/components/simple-modal').then(component => {
      component.default.init();
    });
  }

  if ( document.querySelector('.js-post-author-cta') ) {
    import('~scripts/components/post-author-cta');
  }
}



/**
 * DOMContentLoaded events should be listened to on this file only.
 */
document.addEventListener('DOMContentLoaded', registerBlocks);
document.addEventListener('DOMContentLoaded', registerComponents);

/**
 * Load common components here
 */
document.addEventListener('DOMContentLoaded', () => {
  // Initiates Header Nav Menu
  HeaderNavMenu.init();

  // Initiates Footer Menu
  FooterMenu.init();

  // Initiates Anchor Smooth Scroll utility
  AnchorSmoothScroll.init();

  // Initialises positioning fix for mobile browsers
  ElementBottomPositionMobileFix.init();
});

